import { StyledProps } from '@emotion/react';
import styled from '@emotion/styled';
import { Message } from '@hello-pimster/pimster-crm-sdk';
import { VStack } from '@lib/uikit';
import { memo } from 'react';

import { ChatAvatar } from './ChatAvatar';
import ChatMessage from './ChatMessage';

interface Heights {
    layoutHeight?: number;
    headerHeight?: number;
    footerHeight?: number;
}

interface ChatMessageList extends Heights {
    messages: Message[];
    assistantAvatar: ChatAvatar;
}

const AutoScrollToBottom = styled.div<StyledProps<Heights>>`
    display: flex;
    overflow: auto;
    flex-direction: column-reverse;
    overflow-anchor: auto !important;
    height: ${({ layoutHeight, headerHeight, footerHeight }) =>
        `calc(${layoutHeight}px - ${headerHeight}px - ${footerHeight}px - 10px)`};
`;

const SVStack = styled(VStack)`
    margin-bottom: auto;
`;

const ChatMessageList = ({
    messages,
    assistantAvatar,
    layoutHeight,
    headerHeight,
    footerHeight,
}: ChatMessageList) => {
    return (
        <AutoScrollToBottom
            layoutHeight={layoutHeight}
            headerHeight={headerHeight}
            footerHeight={footerHeight}
        >
            <SVStack>
                {messages.map((message) => (
                    <ChatMessage
                        key={message.id}
                        content={message.content}
                        assistantAvatar={assistantAvatar}
                        from={message.role}
                    />
                ))}
            </SVStack>
        </AutoScrollToBottom>
    );
};

export default memo(ChatMessageList);
